import { Components } from "@thisgorilla/primate-ds";
import { useTheme } from "styled-components";
import { API_CALLS } from "../../../../../API/api_calls";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { useFindContent } from "../../useFindContent";
import PreviewLayout from "../PreviewLayout";
import { PreviewContent } from "../style";
import { PollProps } from "./Poll";
import { PollOptionsContainer } from "./style";

const PollPreview = ({
  id,
  setIsPollCreated,
  pollOptions,
}: PollProps.PollPreviewProps) => {
  const { typography } = useTheme();
  const { content_data } = useFindContent(id) as ArticleProps.WithPollContent;
  const { question } = content_data;

  return (
    <PreviewLayout
      onDelete={() => API_CALLS.ARTICLE.deleteASingleArticleContent(id)}
      onEdit={() => setIsPollCreated(false)}
    >
      <PreviewContent>
        <Components.Text
          text={question}
          style={{ tokenStyle: typography.Body.L }}
          fontWeight="font-weight-semibold"
          lineHeight="line-height-200"
        />
        {pollOptions.map((option, index) => (
          <PollOptionsContainer key={index}>
            <Components.Text
              text={option}
              style={{ tokenStyle: typography.Body.L }}
              renderInSingleLine={true}
              maxLineLength={1}
              lineHeight="line-height-200"
            />
          </PollOptionsContainer>
        ))}
      </PreviewContent>
    </PreviewLayout>
  );
};

export default PollPreview;
